import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'download-app-modal',
    templateUrl: './download-app-modal.component.html',
    styleUrls: ['./download-app-modal.component.scss'],
    standalone: false
})
export class DownloadAppModalComponent implements OnInit {

  urlApple = 'https://apps.apple.com/us/app/amx-2-0/id6453332631'
  urlPlay = 'https://play.google.com/store/apps/details?id=com.aeromexico.aeromexico.app'

  constructor(
    public modal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  onClose() {
    this.modal.close();
  }

}
